import type { Plan } from '@/core/domain';
import type { PlanRepository } from '../repositories/plan-repository';

export class CreatePlanUseCase {
  constructor(private readonly repository: PlanRepository) {}

  async execute(plan: Plan): Promise<Plan> {
    return this.repository.create(plan);
  }
}
